import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { AUDITING_PARAMETER, CATEGORY, LEGENDS } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

export const getAuditingParameterList = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${AUDITING_PARAMETER.GET_AUDITING_PARAMETER_LIST}/${data?._Id}`
      : `${AUDITING_PARAMETER.GET_AUDITING_PARAMETER_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addAuditingParameter = async (data = array()) => {
  try {
    const response = await POST(AUDITING_PARAMETER.GET_AUDITING_PARAMETER_LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateAuditingParameter = async (id, data = array()) => {
  try {
    const url = `${AUDITING_PARAMETER.GET_AUDITING_PARAMETER_LIST}/${id}`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getAllAuditingParametersUsingId = async (data = array()) => {
  try {
    const url = data?.Id
      ? `${AUDITING_PARAMETER.GET_ALL_AUDITING_PARAMETERS}/${data?.Id}`
      : `${AUDITING_PARAMETER.GET_ALL_AUDITING_PARAMETERS}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchAuditingParameterTableAndFilterSchema = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${AUDITING_PARAMETER.GET_AUDITING_PARAMETER_SCHEMA}/${data?._Id}`
      : `${AUDITING_PARAMETER.GET_AUDITING_PARAMETER_SCHEMA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitAuditingParameterFilterData = async (data = array()) => {
  try {
    const response = await POST(AUDITING_PARAMETER.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getLegendsList = async (data = array()) => {
  try {
    const response = await POST(LEGENDS.GET_LEGENDS_LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchLegendsParameterTableAndFilterSchema = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${AUDITING_PARAMETER.GET_LEGENDS_PARAMETER_SCHEMA}/${data?._Id}`
      : `${AUDITING_PARAMETER.GET_LEGENDS_PARAMETER_SCHEMA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitLegendsFilterData = async (data = array()) => {
  try {
    const response = await POST(AUDITING_PARAMETER.SUBMIT_LEGENDS_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getAllLegendsUsingId = async (data = array()) => {
  try {
    const url = data?.Id
      ? `${AUDITING_PARAMETER.GET_LEGENDS_BY_ID}/${data?.Id}`
      : `${AUDITING_PARAMETER.GET_LEGENDS_BY_ID}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addLegends = async (data = array()) => {
    try {
        const response = await POST(AUDITING_PARAMETER.GET_LEGENDS_BY_ID, data);
        return response;
    } catch (error) {
        toast.error(error.message);
    }
};

export const updateLegends = async (id, data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${AUDITING_PARAMETER.GET_LEGENDS_BY_ID}/${id}`;
        const response = await PUT(url, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
